// extracted by mini-css-extract-plugin
export default {"table":"CandidatesTable-module__table__W8VFd","button":"CandidatesTable-module__button__8CIYs","resetButton":"CandidatesTable-module__resetButton__h9Bxx"};